























import { Component, Vue, Prop } from "vue-property-decorator";
import { Message } from "element-ui";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["account"])
})
export default class UploadTool extends Vue {
    @Prop({ type: String })
    title!: string;

    @Prop({ type: String })
    api!: string;

    file: any = null;
    fileName: string = "";

    getFileName(el: any) {
        if (el.target.files[0]) this.file = el.target.files[0];
        let filename = el.currentTarget.files[0].name;
        let postfixname = filename.substring(
            filename.length - 3,
            filename.length
        );
        let fileName: any = document.querySelector("#fileInput .fileName");
        fileName.innerHTML = filename;
        this.fileName = filename
    }
    fnUpload() {
        if (this.file !== null) {
            let data = new FormData();
            data.append("file", this.file);
            data.append("fileName", this.fileName);
            this.submit(data);
        }
    }
    async submit(data: any) {
        await Vue.axios.post(this.api, data);
    }
}
